<div class="panel panel-default" id="translate" >
	<div class="panel-heading">
		<h1 class="d-block">
			{{ 'statistic' | translate }} :
		</h1>
        <!-- <div class="px-4 d-inline-block">
            <span class="text-secondary my-2 my-sm-0" >
                <input type="checkbox" (click)="changeShs($event)" [checked]="shs" />
                {{ 'SHS' | translate }} -
            </span>
            <span class="text-secondary my-2 my-sm-0'">
                <input type="checkbox" (click)="changeLmg($event)" [checked]="lmg" />
                {{ 'LMG' | translate }}
            </span>
        </div> -->
	</div>
	<div class="panel-body">
		<div class="tz-gallery col-12 py-0">
        <form #f="ngForm" (ngSubmit)="onSearch(f.value)" class="form-inline">   
            <table class="table-responsive-md">
                <tbody>
                    <tr class="row">
                        <!-- <td class="carbold col-12 col-xl-3">
                            <label class="text-left">{{ 'titre_trad' | translate }} :</label>
                            <input name="titre" ngModel class="form-control form-control-sm w-100" type="text" placeholder="{{ 'term' | translate }}" aria-label="Terme">
                        </td> 
                        <td class="carbold col-12 col-xl-3">
                            <label class="text-left">{{ 'titre_org' | translate }} :</label>
                            <input name="titre_par" ngModel class="form-control form-control-sm w-100" type="text" placeholder="{{ 'term' | translate }}" aria-label="Terme">
                        </td>  -->
                        <td class="bold col-12 col-xl-4">
                            <label class="text-left">{{ 'auteur_advanced' | translate }} :</label>
                            <input name="auteur" ngModel class="form-control form-control-sm w-100" type="text" placeholder="{{ 'term' | translate }}" aria-label="Terme">
                        </td> 
                        <td class="bold col-12 col-xl-4">
                            <label class="text-left">{{ 'sexe_auteur_advanced' | translate }} :</label>
                            <select name="sexe" ngModel class="form-control form-control-sm w-100">
                                <option value="M">{{ 'M' | translate }}</option>
                                <option value="F">{{ 'F' | translate }}</option>
                            </select>
                        </td> 
                        <td class="bold col-12 col-xl-4">
                            <label class="text-left">{{ 'nat_auteur_advanced' | translate }} :</label>
                            <select name="nat" ngModel class="form-control form-control-sm w-100">
                                <option  value=" " selected>{{ 'chosepays' | translate }}</option>
                                <option  *ngFor="let y of listnat" value='{{ y.code }}'>
                                    {{ y.natinalite }}
                                </option>
                            </select>
                        </td> 
                        <td class="bold col-12 col-xl-4">
                            <label class="text-left">{{ 'pays_org' | translate }} : </label>
                            <select name="paysedition" ngModel class="form-control form-control-sm w-100">
                                <option  value=" " selected>{{ 'chosepays' | translate }}</option>
                                <option  *ngFor="let y of paysedition" value='{{ y.paysedition }}'>
                                    {{ y.paysedition }}
                                </option>
                            </select>
                        </td> 
                        <td class="bold col-12 col-xl-4">
                            <label class="text-left">{{ 'langue_source' | translate }} : </label>
                            <select name="langsource" ngModel class="form-control form-control-sm w-100">
                                <option  value=" " selected>{{ 'choselang' | translate }}</option>
                                <option  *ngFor="let y of langueSource" value='{{ y.Langsource }}'>
                                    {{ y.Langsource }}
                                </option>
                            </select>
                        </td> 
                        <td class="bold col-12 col-xl-4">
                            <label class="text-left">{{ 'langue_cible' | translate }} : </label>
                            <select name="langcible" ngModel class="form-control form-control-sm w-100">
                                <option  value=" " selected>{{ 'choselang' | translate }}</option>
                                <option  *ngFor="let y of langueCible" value='{{ y.langcible }}'>
                                    {{ y.langcible }}
                                </option>
                            </select>
                        </td> 
                        <td class="bold col-12 col-xl-6">
                            <label class="text-left">{{ 'theme_topo' | translate }} : </label>
                            <select name="themeg" ngModel class="form-control form-control-sm w-100" (change)="getSubtheme($event.target.value)" >
                                <option disabled selected>{{ 'chosetheme' | translate }}</option>
                                <option  *ngFor="let t of themes" value='{{ t.id }}'>
                                    {{ t.theme }}
                                </option>
                            </select>
                        </td>
                        <td class="bold col-12 col-xl-6">
                            <label class="text-left">--></label>
                            <!-- <span class="text-danger" *ngIf="themesel.value!='' && themesel.value!='Choisir un thème' && themesel.value!='أختر الموضوع'">{{ 'chosesubtheme' | translate }}<br /></span> -->
                            <select name="theme" ngModel class="form-control form-control-sm w-100">
                                <option  value=" " selected>{{ 'chosesubtheme' | translate }}</option>
                                <option  *ngFor="let t of subthemes" value='{{ t.code }}'>
                                    {{ t.theme }}
                                </option>
                            </select>
                        </td> 
                        <td class="bold col-12 col-xl-6">
                            <label class="text-left">{{ 'annee_edition' | translate }} : {{ 'entre' | translate }}</label>
                            <select name="first"  ngModel class="form-control form-control-sm w-100" (change)="onchangeDate($event.target.value)">
                                <option value=" " selected>{{ 'chosedate' | translate }}</option>
                                <option *ngFor="let y of years">{{ y }}</option>
                            </select>
                        </td>
                        <td class="bold col-12 col-xl-6">
                            <label class="text-left">{{ 'et' | translate }}</label>
                            <select name="end" ngModel class="form-control form-control-sm w-100">
                                <option selected>{{ 'chosedate' | translate }}</option>
                                <option *ngFor="let y of years2">{{ y }}</option>
                            </select>
                        </td> 
                        <td class="bold col-12 col-xl-4">
                            <label class="text-left">{{ 'limit' | translate }} :</label>
                            <select name="limit" ngModel #limit class="form-control form-control-sm w-100">
                                <option value="10" selected >10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                            </select>
                        </td> 
                        <td class="bold col-12 col-xl-4">  
                            <label class="text-left">{{ 'dspchart' | translate }} : <span *ngIf="chartrequired" class="text-danger mx-2"> {{ 'required' | translate }} </span></label>
                            <select name="chartselect" class="form-control form-control-sm w-100" ngModel>
                                <!-- <option [value]="'ALL'" >{{ 'all' | translate}}</option> -->
                                <!-- <option [value]="'TM'" >{{ 'TM' | translate }}</option> -->
                                <!-- <option [value]="'DME'" >{{ 'DME' | translate }}</option> -->
                                <option [value]="''" selected ></option>
                                <option [value]="'TPA'" selected >{{ 'TPA' | translate }}</option>
                                <option [value]="'TA'" >{{ 'TA' | translate }}</option>
                                <option [value]="'TDA'" >{{ 'TDA' | translate }}</option>
                                <!-- <option [value]="'TDT'" >{{ 'TDT' | translate }}</option> -->
                                <option [value]="'DS'" >{{ 'discip' | translate }}</option>
                                <option [value]="'EDT'" >{{ 'editeurs' | translate }}</option>
                                <option [value]="'PEDT'" >{{ 'pays_org' | translate }}</option>
                                <option [value]="'LSRC'" >{{ 'langues_source' | translate }}</option>
                                <!-- <option [value]="'NT'" >{{ 'NT' | translate }}</option>
                                <option [value]="'TPN'" >{{ 'TPN' | translate }}</option> -->
                            </select>
                        </td> 
                    </tr> 
                </tbody>
            </table>
            <button class="btn btn-success my-3" type="submit">{{ 'recherche' | translate }}</button>
        </form>
                <!-- <mat-label class="mat-label">{{"dspchart" | translate}} :</mat-label>-->

		</div>
    </div>
	<div class="panel-body">
		<div class="tz-gallery col-12 py-0">
            <div class="row">
                <!-- <div class="col-12 col-xl-4 my-4" *ngIf="charts.includes('TM')"> -->
                <div class="col-6 mmc" *ngIf="charts == 'TPA'">
                    <div class="card card-info">
                        <div class="card-header py-1 pointer">{{ 'TPA' | translate }}</div>
                        <div class="card-body py-10">
                            <!-- <app-tabyaeredit [linkv]="linkyears"></app-tabyaeredit> -->
                            <app-charteyears [linkv]="linkyears"></app-charteyears>
                        </div>
                    </div>
                </div>
                <div class="col-6 mmc" *ngIf="charts == 'TA'">
                    <div class="card card-info">
                        <div class="card-header py-1 pointer">{{ 'TA' | translate }}</div>
                        <div class="card-body py-10">
                            <app-chartedition [linkv]="linkta" [lcount]="totala" [namec]="'TA' | translate" [namecol]="'langues_source' | translate"></app-chartedition>
                        </div>
                    </div>
                </div>
                <div class="col-6 mmc" *ngIf="charts == 'TDA'">
                    <div class="card card-info">
                        <div class="card-header py-1 pointer">{{ 'TDA' | translate }}</div>
                        <div class="card-body py-10">
                            <app-chartedition [linkv]="linktda" [lcount]="totalda" [namec]="'TDA' | translate" [namecol]="'langues_cible' | translate"></app-chartedition>
                        </div>
                    </div>
                </div>
                <div class="col-6 mmc" *ngIf="charts == 'DS'">
                    <div class="card card-info">
                        <div class="card-header py-1 pointer">{{ 'thematiques' | translate }}</div>
                        <div class="card-body">                            
                            <app-chartedition [linkv]="linkdescip" [lcount]="total" [namec]="'thematiques' | translate" [namecol]="'thematiques' | translate"></app-chartedition>
                        </div>
                    </div>
                </div>
                <div class="col-6 mmc"  *ngIf="charts == 'EDT'">
                    <div class="card card-info">
                        <div class="card-header py-1 pointer">{{ 'editeurs' | translate }}</div>
                        <div class="card-body">
                            <app-chartedition [linkv]="linkediteur" [lcount]="total" [namec]="'editeurs' | translate" [namecol]="'editeurs' | translate"></app-chartedition>
                        </div>
                    </div>
                </div>
                <div class="col-6 mmc"  *ngIf="charts == 'PEDT'">
                    <div class="card card-info">
                        <div class="card-header py-1 pointer">{{ 'pays_org' | translate }}</div>
                        <div class="card-body">
                            <app-chartedition [linkv]="linkpays" [lcount]="total" [namec]="'pays_org' | translate" [namecol]="'pays_org' | translate"></app-chartedition>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-12 col-xl-4 my-4" *ngIf="charts.includes('DME')">
                    <div class="card card-info">
                        <div class="card-header py-1 pointer">{{ 'DME' | translate }}</div>
                        <div class="card-body">
                            <app-chartedition [linkv]="linkdme" [namec]="'DME' | translate" [namecol]="'annee_edition' | translate"></app-chartedition>
                        </div>
                    </div>
                </div> -->                
                <div class="col-6 mmc" *ngIf="charts.includes('LSRC')">
                    <div class="card card-info">
                        <div class="card-header py-1 pointer">{{ 'langues_source' | translate }}</div>
                        <div class="card-body py-10">
                            <app-chartedition [linkv]="linklangsrc" [lcount]="total" [namec]="'langues_source' | translate" [namecol]="'langues_source'"></app-chartedition>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-12 col-xl-4 my-4" *ngIf="charts.includes('LCLB')">
                    <div class="card card-info">
                        <div class="card-header py-1 pointer">{{ 'langues_cible' | translate }}</div>
                        <div class="card-body">
                            <app-tablangcbl [linkv]="linklangcib"></app-tablangcbl>
                            <app-chartelangcible [linkv]="linklangcib"></app-chartelangcible>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
    
</div>